// GlobalLoadingContext.js
import React, {
  createContext,
  useState,
  useContext,
  useCallback,
  useMemo,
} from 'react';

const GlobalLoadingContext = createContext();

export const GlobalLoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  // 👇 stable function identities
  const startLoading = useCallback(() => setLoading(true), []);
  const stopLoading = useCallback(() => setLoading(false), []);

  const value = useMemo(
    () => ({ loading, startLoading, stopLoading }),
    [loading, startLoading, stopLoading]
  );

  return (
    <GlobalLoadingContext.Provider value={value}>
      {children}
    </GlobalLoadingContext.Provider>
  );
};

export const useGlobalLoading = () => useContext(GlobalLoadingContext);
